import { RefObject, ElementType, MouseEventHandler } from 'react';

import { IconViewSizes } from '../IconView/IconView.types';

export enum ButtonTypes {
  Button = 'button',
  Submit = 'submit',
  Reset = 'reset',
}

export type TButtonTheme =
  /* Standard button themes synced with design*/
  | 'primary'
  | 'secondary'
  | 'text-primary'
  | 'text-thirty'
  | 'text-error'
  | 'text-secondary'
  | 'outline-primary'
  | 'primary-white'
  | 'secondary-white'
  | 'primary-light'
  | 'fixed-color'
  /* registration with design Custom Button kind*/
  | '10'
  | '13'
  | '16'
  /* synced with design CustomButton kind */
  | 'primary-text'
  | 'fixed-icon';

export type TButtonRounding = '0' | '1' | '2';
export type TButtonSize = '0' | '10' | '20' | '30';

export const buttonIconSizeMap: Record<TButtonSize, IconViewSizes> = {
  '0': IconViewSizes.XSmall,
  '10': IconViewSizes.Small,
  '20': IconViewSizes.Medium,
  '30': IconViewSizes.Large,
};

export interface IButton<T> {
  tabIndex?: number;
  onClick?: MouseEventHandler<T>;
  onContextMenu?: MouseEventHandler<T>;
  className?: string;
  Icon?: ElementType;
  setRef?: RefObject<T>;
  size?: TButtonSize;
  rounding?: TButtonRounding;
  theme?: TButtonTheme;
  dataTest?: string;
  isLoading?: boolean;
  isDisabled?: boolean;
  id?: string;
}
